/**
 * Manual `{placeholder}` interpolation for the hand-rolled typed i18n.
 *
 * The translations are plain TypeScript strings with no ICU runtime behind
 * them, so every caller that needs a value in a sentence goes through here.
 * An unknown key is left as its own `{placeholder}` rather than blanked, so a
 * mistyped token shows up in the UI instead of silently swallowing the word.
 */
export function fill(template: string, values: Record<string, string>): string {
  return template.replace(/\{(\w+)\}/g, (_match, key: string) => values[key] ?? `{${key}}`);
}
